import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { CONSTANTS as C } from "config";
import { Button, Input, Spin } from "antd";
import { UTILS } from "utils";
import { useUpdatePasswordMutation } from "redux/settings/settingsSlice";
import { useDispatch, useSelector } from "react-redux";
import { SettingErrorAction } from "redux/actions";
import AppInput from "components/ui/AppInput";
import AppButton from "components/ui/AppButton";
const ProfilePasswordUpdate = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [updatePassword, { isLoading }] = useUpdatePasswordMutation();
  const { isError, passwordError } = useSelector(
    (state) => state?.SettingErrorReducer
  );
  const [state, setState] = useState({
    values: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    errors: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        [name]: value,
      },
      errors: {
        ...prevState.errors,
        [name]: "",
      },
    }));
  };

  const updateState = (key, value) => {
    setState((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
      },
      errors: {
        ...prevState.errors,
        [key]: value,
      },
    }));
  };

  const resetState = (key, value) => {
    setState((prevState) => ({
      ...prevState,
      values: {},
      errors: {},
    }));
  };

  const ErrorMessages = [
    t("Old password is a required field"),
    t("New password is a required field"),
    t("Confirm password is a required field"),
    t("The new password and the confirm password must be the same."),
  ];

  const validateInput = () => {
    dispatch(SettingErrorAction.setPasswordError(null));
    let isValid = true;
    if (!state?.values?.newPassword) {
      isValid = false;
      updateState(C.NEW_PASSWORD, ErrorMessages[1]);
    }
    if (!state?.values?.oldPassword) {
      isValid = false;
      updateState(C.OLD_PASSWORD, ErrorMessages[0]);
    }
    if (!state?.values?.confirmPassword) {
      isValid = false;
      updateState(C.CONFIRM_PASSWORD, ErrorMessages[2]);
    }
    if (state?.values?.newPassword !== state?.values?.confirmPassword) {
      updateState(C.CONFIRM_PASSWORD, ErrorMessages[3]);
      updateState(C.NEW_PASSWORD, ErrorMessages[3]);
      isValid = false;
    }
    return isValid;
  };
  const updateMyPassword = async () => {
    const language = await UTILS?.asyncLocalStorage.getLanguage();
    if (!validateInput()) {
      return;
    } else {
      const obj = {
        oldPassword: state.values.oldPassword,
        newPassword: state.values.newPassword,
        language,
      };
      await updatePassword(obj).unwrap();
      resetState();
    }
  };
  return (
    <>
      <Spin spinning={isLoading}>
        {(isError || passwordError) && (
          <div className="text-red-600">{passwordError}</div>
        )}
        <h3 className="text-19px font-medium">{t("Security")}</h3>
        <div className="pb-2 w-1/2 mt-2">
          <AppInput label={t("Current password")} type="password" name="oldPassword" placeholder={t("Enter current password")} value={state?.values?.oldPassword} error={state?.errors?.oldPassword && state?.errors?.oldPassword} onInput={(event) => {handleChange(event);}}/>
        </div>
        <div className="pb-2 w-full flex gap-2 mt-2">
          <AppInput label={t("New password")} type="password" name="newPassword" placeholder={t("Enter new password")} value={state?.values?.newPassword} error={state?.errors?.newPassword && state?.errors?.newPassword} onInput={(event) => {handleChange(event);}}/>
          <AppInput label={t("Confirm new password")} type="password" name="confirmPassword" placeholder={t("Confirm new password")} value={state?.values?.confirmPassword} error={state?.errors?.confirmPassword && state?.errors?.confirmPassword} onInput={(event) => {handleChange(event);}}/>
        </div>
        <div className="mt-2">
          <AppButton
            size="md"
            className="text-white border-blue-500 rounded bg-blue-500 px-8"
            onClick={updateMyPassword}
          >
            {t("Update")}
          </AppButton>
        </div>
      </Spin>
    </>
  );
};

export default ProfilePasswordUpdate;
